import { Button, Text, Inline, Stack, textVariants, vars } from '@etg/wings';
import { CaretDown } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { AnimatePresence, m as motion } from 'framer-motion';
import { price as priceUtil } from '@eti/utils';
import { useSeatCharacteristicMeta } from '../hooks/useSeatCharacteristicMeta';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  container: css`
    align-items: flex-start;
    border: 1px solid #e5e5e5;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 56px;
    padding: 8px;
    width: 300px;

    > span {
      width: 100%;
    }
  `,
  icon: css`
    height: 32px;
    width: 32px;
  `,
  buttonContent: css`
    justify-content: space-between;
    width: inherit;
  `,
  expandableContentWrapper: css`
    width: 80%;
  `,
  priceDescription: css`
    text-align: start;
    width: inherit;
  `
};
const SeatCharacteristicsPanel = _ref => {
  let {
    characteristic,
    isUnavailable,
    priceFrom,
    isOpen,
    onToggle
  } = _ref;
  const {
    iconUrl,
    label,
    description,
    priceFromLabel
  } = useSeatCharacteristicMeta(characteristic, isUnavailable);
  return /*#__PURE__*/_jsx(Button, {
    "aria-controls": "seat-characteristic-details",
    "aria-expanded": isOpen,
    className: styles.container,
    "data-testid": "seat-characteristic-panel",
    onClick: onToggle,
    children: /*#__PURE__*/_jsxs(Inline, {
      alignY: isOpen ? 'top' : 'center',
      className: styles.buttonContent,
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: isOpen ? 'top' : 'center',
        className: styles.expandableContentWrapper,
        spacing: 8,
        children: [iconUrl && /*#__PURE__*/_jsx("img", {
          alt: "",
          "aria-hidden": "true",
          className: styles.icon,
          src: iconUrl
        }), /*#__PURE__*/_jsxs(Stack, {
          align: "start",
          className: styles.priceDescription,
          children: [/*#__PURE__*/_jsx(Text, {
            variant: textVariants._14_BOLD,
            children: label
          }), /*#__PURE__*/_jsx(AnimatePresence, {
            children: isOpen && /*#__PURE__*/_jsx(motion.div, {
              animate: {
                height: 'auto',
                opacity: 1
              },
              exit: {
                height: 0,
                opacity: 0
              },
              id: "seat-characteristic-details",
              initial: {
                height: 0,
                opacity: 0
              },
              style: {
                overflow: 'hidden'
              },
              transition: {
                duration: 0.3
              },
              children: /*#__PURE__*/_jsxs(Stack, {
                align: "start",
                spacing: 0,
                children: [!isUnavailable && /*#__PURE__*/_jsxs(Text, {
                  variant: textVariants._12,
                  children: [priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
                }), /*#__PURE__*/_jsx(Text, {
                  variant: textVariants._12,
                  children: description
                })]
              })
            }, "seatCharateristics-description")
          })]
        })]
      }), /*#__PURE__*/_jsx(motion.div, {
        animate: {
          rotateX: isOpen ? 180 : 0
        },
        style: {
          display: 'flex'
        },
        children: /*#__PURE__*/_jsx(CaretDown, {
          color: vars.colors.text.primary,
          "data-testid": "seatCharateristics-readMoreButtonIcon",
          size: 24,
          weight: "light"
        })
      })]
    })
  });
};
export default SeatCharacteristicsPanel;
//# sourceMappingURL=SeatCharacteristicsPanel.js.map